export default "__VITE_ASSET__CQoatY5J__"